import { ReplaySubject, forkJoin } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
export class SolScriptsLoaderService {
    constructor(document) {
        this.document = document;
        this._loadedLibraries = {};
    }
    lazyLoadQuill() {
        return forkJoin([
            this.loadScript('assets/plugins/rotator.js'),
            this.loadScript('assets/plugins/slider-edge-config.js')
        ]);
    }
    loadScript(url) {
        if (this._loadedLibraries[url]) {
            return this._loadedLibraries[url].asObservable();
        }
        this._loadedLibraries[url] = new ReplaySubject();
        const script = this.document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = url;
        script.onload = () => {
            this._loadedLibraries[url].next();
            this._loadedLibraries[url].complete();
        };
        this.document.body.appendChild(script);
        return this._loadedLibraries[url].asObservable();
    }
    loadStyle(url) {
        if (this._loadedLibraries[url]) {
            return this._loadedLibraries[url].asObservable();
        }
        this._loadedLibraries[url] = new ReplaySubject();
        const style = this.document.createElement('link');
        style.type = 'text/css';
        style.href = url;
        style.rel = 'stylesheet';
        style.onload = () => {
            this._loadedLibraries[url].next();
            this._loadedLibraries[url].complete();
        };
        const head = document.getElementsByTagName('head')[0];
        head.appendChild(style);
        return this._loadedLibraries[url].asObservable();
    }
}
SolScriptsLoaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SolScriptsLoaderService_Factory() { return new SolScriptsLoaderService(i0.ɵɵinject(i1.DOCUMENT)); }, token: SolScriptsLoaderService, providedIn: "root" });
